import React from "react";
import { Button } from "@fluentui/react-components";
import { PeopleRegular, PersonAddRegular, DismissRegular } from "@fluentui/react-icons";
import styles from "./personField.module.scss";
import { useTranslation } from "../../shared/translation/Translation";
import AntiXssTextField from "../textField/AntiXssTextField";
import { IPerson } from "../../models/Person";

export interface PersonFieldProps {
    person: IPerson;
    isFormTypeUpdate: boolean;

    handleDataChange: (value: IPerson) => void;
    handleDelete: (key: string) => void;
}

const PersonField: React.FC<PersonFieldProps> = (props: PersonFieldProps) => {
    const messages = useTranslation();

    const handleOnChange = (field: string, value: string) => {
        props.person[field] = value;
        props.handleDataChange(props.person);
    };

    return (
        <div className={styles.fieldRow}>
            <div className={styles.iconWrapper}>
                {props.isFormTypeUpdate ? <PeopleRegular /> : <PersonAddRegular />}
            </div>
            <AntiXssTextField
                autoComplete="name-off"
                placeholder={messages.meetingModals.fullnamePlaceholder}
                className={styles.inputComponent}
                isInvalid={props.person.name.length > 0 && !props.person.validateName()}
                handleDataChange={(value) => handleOnChange("name", value)}
                text={props.person.name}
                required={true}
                disabled={props.isFormTypeUpdate && !props.person.isNew}
                showSuccessIndicator={props.person.validateName()}
            />
            <AntiXssTextField
                autoComplete="email-off"
                placeholder={messages.meetingModals.emailPlaceholder}
                className={styles.inputComponent}
                isInvalid={props.person.email.length > 0 && !props.person.validateEmail()}
                handleDataChange={(value) => handleOnChange("email", value)}
                text={props.person.email}
                required={true}
                errorMessage={messages.meetingModals.validation.invalidEmail}
                disabled={props.isFormTypeUpdate && !props.person.isNew}
                showSuccessIndicator={props.person.validateEmail()}
            />
            <Button
                title="Delete"
                className={styles.buttonComponent}
                icon={<DismissRegular />}
                appearance="transparent"
                onClick={() => props.handleDelete(props.person.key)}
                disabled={props.isFormTypeUpdate && !props.person.isNew}
            />
        </div>
    );
};

export default PersonField;
